import React from "react";

interface ModalProps {
  children: React.ReactNode;
  onClose: () => void;
  hideCloseButton?: boolean;
}

export default function Modal({ children, onClose, hideCloseButton }: ModalProps) {
  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div
        className="flex flex-col gap-0 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 border border-gray-200 w-full max-w-md"
      >
        {children}
        {!hideCloseButton && (
          <button
            onClick={onClose}
            className="mt-2 px-3 py-1 transition duration-200 bg-gray-300 hover:bg-gray-400 rounded"
          >
            Cancelar
          </button>
        )}
      </div>
    </div>
  );
}
